<template>
  <q-list
    padding
    separator
    bordered
    class="rounded-borders"
    v-bind="$attrs"
    :dense="$q.screen.gt.sm"
  >
    <slot />
  </q-list>
</template>

<script>
export default {
  name: 'SortableList',
  inheritAttrs: false
}
</script>

<style scoped>

</style>
